import { render, staticRenderFns } from "./CIModal.vue?vue&type=template&id=20ce4a35&scoped=true&"
import script from "./CIModal.vue?vue&type=script&lang=js&"
export * from "./CIModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce4a35",
  null
  
)

export default component.exports